export default "__VITE_ASSET__DPiyuzwT__"